<template>
  <div class="home page-container">
    <div class="home_welcome">
      <div class="mb_header_fixed_container">
        <div v-show="!isHeaderFixed2" class="header_head header-bottom mb_header_fixed">
          <div class="zip_container" v-if="shippingMethodGlobal === 'Delivery'">
            <div class="white" @click="toggleShippingMethodModalVisibility_mobile(true)">
              <img src="../../assets/img/pin.svg"/>
              <p class="white_txt home-10px" v-if="userZip">{{ $t('delivery_to') }} {{ userZip }}</p>
              <p class="white_txt home-10px" v-if="!userZip">{{ $t('delivery_to') }} {{ $t('enter_zip_code') }}</p>
              <div>
                <i class="fa fa-caret-down" style="margin-left: 10px" aria-hidden="true"></i>
              </div>
            </div>
          </div>

          <div class="zip_container" v-if="shippingMethodGlobal === 'Pickup'">
            <div class="white" @click="toggleShippingMethodModalVisibility_mobile(true)">
              <img src="../../assets/img/pin.svg"/>
              <p class="white_txt home-10px" v-if="this.warehouseLocation && this.warehouseLocation !== 'All'">
                {{ $t('pick_up_from') }} {{ this.warehouseLocation }}</p>
              <p class="white_txt home-10px"  v-else>{{ $t('pick_up_from') }} {{ $t('select_store') }}</p>
              <div>
                <i class="fa fa-caret-down" style="margin-left: 10px" aria-hidden="true"></i>
              </div>
            </div>
          </div>

          <a class="lang" @click="langChanged">
            <span>中文 / EN</span>
          </a>
        </div>
        <mbHeader2 v-show="isHeaderFixed2"></mbHeader2>
      </div>
      <div class="header_head">
        <div class="welcome" @click="$router.push({path:'/account'})">
          <img class="account-icon" src="../../assets/img/profile-button-bg.svg" alt="">
          <p v-if="loggedIn" class="hello_mobile">Hi, {{ this.userDetails.FirstName }}</p>
          <p v-else class="hello_mobile">Hi</p>
        </div>
      </div>
      <div class="statement_holder home-empty-padding">
        <p class="statement">{{ $t('your_favourite_asian_groceries') }}</p>
        <p class="statement">{{ $t('delivery_to_your_door') }}</p>
      </div>
<!--     <div class="header_foot">
       <div class="zip_container" v-if="shippingMethodGlobal === 'Pickup'">
          <div class="white" @click="toggleShippingMethodModalVisibility(true)">
            <img src="../assets/img/pin.svg"/>
            <p class="white_txt">Pickup</p>
          </div>
          <div class="white black" @click="setLocation(true)">
            <p class="white_txt" v-if="this.warehouseLocation && this.warehouseLocation !== 'All'">
              {{ this.warehouseLocation }}</p>
            <p class="white_txt" v-else>{{ $t('select_store') }}</p>
            <img src="../assets/img/clock.svg"/>
          </div>
        </div>
        <img/>
      </div> -->
    </div>
    <div class="home_display">
      <div>
        <!--        <img class="home_banner" src="../assets/img/onions.png"/>-->
        <!--banner-->
        <div class="banner">
          <swiper :options="bannerSwiper">
            <swiper-slide
              v-for="(item,index) in filterBillboard"
              :data-index="index" :key="index">
              <div v-if="item.URL"><a style="cursor: pointer" @click="onClickBillboard(item.URL, item.MIMEType)"><img
                class='swiImg' :src='item.Image'/></a></div>
              <div v-else><img class='swiImg' :src='item.Image'/></div>
            </swiper-slide>
          </swiper>
          <div class="banner-button-prev">
            <font-awesome-icon icon="chevron-left" :style="{ color: 'black', fontSize: '20px', marginRight: '10px' }"/>
          </div>
          <div class="banner-button-next">
            <font-awesome-icon icon="chevron-right" :style="{ color: 'black', fontSize: '20px', marginLeft: '10px'  }"/>
          </div>
        </div>
      </div>
      <div class="mid-section">
        <!-- <div class="icon-holders">
          <div class="mobile_icon">
            <img src="../../assets/img/freeDelivery.svg" style="height: 24px; width: 24px"/>
            <p>{{ $t('free_delivery_over') }}</p>
          </div>
          <div class="mobile_icon">
            <img src="../../assets/img/homeTicket.svg" style="height: 24px; width: 24px"/>
            <p>{{ $t('the_first_order') }}</p>
          </div>
          <div class="mobile_icon">
            <img src="../../assets/img/homeGuarantee.svg" style="height: 24px; width: 24px"/>
            <p>{{ $t('quality_guarantee') }}</p>
          </div>
        </div> -->
        <div ref="searchBarRef" class="search-bar"  @click="$router.push({path:'/mobileSearch'})">
          <input
            type="text"
            :placeholder="$t('search_for')"
          >
          <div class="search hoverBtn">
            <font-awesome-icon icon="search" :style="{ color: 'white', fontSize: '12px' }"/>
          </div>
        </div>
      </div>
    </div>

    <div class="category-buttons">
      <ul class="groupsMobile">
        <li :ref="'groups'+index"
            v-for="(item, index) in groups"
            :key="index"
            >
          <div class="group-button-container">
            <div class="image-placeholder" @click="navGo(item.ProductGroup_id)">
              <img class="button-image" :src="item.Image" alt="">
            </div>
            <p class="group-button-name">{{ curIsEnglish ? item.Name : item.Description }}</p>
          </div>
        </li>
      </ul>
    </div>

    <!-- <div class="recommendation-section">
      <h2 class="rec-title">{{ $t('today_recommendation') }}</h2>
      <div class="rec-container">
        <div
          v-for="(item,index) in customButtonCategories"
          v-show="curIsEnglish && checkViewableLanguages(item.ViewableLanguages, 'en') || curIsChinese && checkViewableLanguages(item.ViewableLanguages, 'ch')"
          :key="index">
          <img
            v-if="curIsEnglish && checkViewableLanguages(item.ViewableLanguages, 'en')"
            class="rec-img"
            :src="item.Image"
            alt=""
            @click="selectCustomCategory(item)">
          <img
            v-if="curIsChinese && checkViewableLanguages(item.ViewableLanguages, 'ch')"
            class="rec-img"
            :src="item.Image"
            alt=""
            @click="selectCustomCategory(item)">
        </div>
      </div>
    </div> -->
    <div v-for="(item,index) in showCustomNotBtnCategories"
         v-model="local=item.Products=='local'"
         data-index="index"
         :key="index" class="small-swiper-container">
      <div class="small-swiper">
        <!--        <div v-if="index === 1" class="centerBanner">-->
        <!--          <img src="../assets/img/afmCenterBanner.png" @click="selectCustomCategory(item)"/>-->
        <!--        </div>-->
        <!--        v-if="item.Name === 'Best Seller'"-->
        <div class="page-width">
          <div v-if="item.ListViewType!=='middle-image' && checkViewableLanguages(item.ViewableLanguages, $i18n.locale) && item.Products.length>0"
            class="padding border-bottom-10">
            <div class="text-start">
              <div class="titleTop">
                <h2>{{ curIsEnglish ? item.Name : item.Description }}</h2>
                <div class="titleRight" @click="selectCustomCategory(item)">{{$t('view_all')}} ></div>
              </div>
            </div>
            <swiper :options="howToSwiper">
              <swiper-slide v-for="(p, index) in item.Products" :key="index" v-if="!p.IsStopSale">
                <mobileProductCardSmall
                  v-bind:img="p.Thumbnail"
                  v-bind:link="p.link"
                  v-bind:brand="p.Brand"
                  v-bind:rating="p.Rating"
                  v-bind:name="curIsEnglish ? p.Name : p.Description"
                  v-bind:isPromotion="p.IsPromotion"
                  v-bind:price="p.Price"
                  v-bind:item="p"
                  v-bind:quantity="p.Quantity"
                  v-bind:key="index"
                ></mobileProductCardSmall>
              </swiper-slide>
              <!-- <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div> -->
            </swiper>
          </div>
          <div v-if="item.ListViewType==='middle-image' && item.IsMobile === true && item.Image" class="centerBanner">
            <img height="60px" :src="item.Image" @click="selectCustomCategory(item)"/>
          </div>
        </div>
      </div>
    </div>
    <div class="category2-list">
      <div class="filter-bar">
        <swiper :options="catScroll" class="cat-swiper">
          <swiper-slide v-for="(item,index) in categories" :key="index" class="cat-slide">
            <p @click="setNewCategory(item)"
               :class="selectedCategoryProducts.Name === item.Name ? 'selected' : '' "
               v-if='$i18n.locale=="en"'>
              {{ capitalizeOnlyFirstLetter(item.Name) }}
            </p>
            <p @click="setNewCategory(item)"
               :class="selectedCategoryProducts.Name === item.Name ? 'selected' : '' "
               v-if='$i18n.locale=="ch"'>
              {{ item.Description }}
            </p>
          </swiper-slide>
        </swiper>
      </div>
      <ul>
        <li v-for="(p, index) in this.selectedCategoryProducts.Products" v-if="(showMore || index<  6)">
          <mobileProductCardLarge 
            v-bind:img="p.Thumbnail"
            v-bind:link="p.link"
            v-bind:brand="p.Brand"
            v-bind:rating="p.Rating"
            v-bind:name="curIsEnglish ? p.Name : p.Description"
            v-bind:isPromotion="p.IsPromotion"
            v-bind:price="p.Price"
            v-bind:item="p"
            v-bind:quantity="p.Quantity"
            v-bind:key="index"></mobileProductCardLarge>
        </li>
      </ul>
      <div class="show-more-container" v-if="!showMore && this.selectedCategoryProducts.Products.length > 6">
        <button class="show-more-button" @click="clickShowMore">{{ $t('showMore') }}</button>
      </div>

      <recommended></recommended>

    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import {mapActions, mapMutations, mapState} from 'vuex';
import {isUserAuthenticated, flyToElement} from "../../store/modules/cart";
import productCard from "../productCard";
import productList from '../productList';
import mobileProductCardSmall from './mobileProductCardSmall';
import mobileProductCardLarge from './mobileProductCardLarge';
import recommended from '../recommended';
import mbHeader2 from '../../components/mobile/mbHeader2';
import Utils from "../../assets/js/util";
import {
  locales,
  outOfStockSorts,
  showRecommendedData
} from '../../mixin'

const VERTICAL_NUM = 7; // 竖着排的数量

export default {
  name: "mobileHome",
  mixins: [showRecommendedData, outOfStockSorts, locales],
  components: {
    productCard,
    mobileProductCardSmall,
    mobileProductCardLarge,
    recommended,
    mbHeader2
  },
  data() {
    return {
      showMore: false,
      categories: [],
      allCategoryProducts: [],
      selectedCategoryProducts: {
        Products: []
      },
      bannerSwiper: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        simulateTouch: false,
        navigation: {
          nextEl: '.banner-button-next',
          prevEl: '.banner-button-prev',
        },
      },
      howToSwiper: {
        slidesPerView: 4,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        breakpoints: {
          300: {
            slidesPerView: 2,
          },
          390: {
            slidesPerView: 3,
          },
          500: {
            slidesPerView: 3
          },
          600: {
            slidesPerView: 5
          },
          800: {
            slidesPerView: 6
          }
        }
      },
      productSwiper: {
        slidesPerView: 5,
        navigation: {
          nextEl: '.swiper-button-next.swp2',
          prevEl: '.swiper-button-prev.swp2',
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
          },
          //when width >= 480
          480: {
            slidesPerView: 2,
          },
          767: {
            slidesPerView: 2,
          },
          //when width >= 640
          990: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 5,
          }
        }
      },
      catScroll: {
        slidesPerView: 4,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        breakpoints: {
          300: {
            slidesPerView: 2,
          },
          390: {
            slidesPerView: 3,
          },
          500: {
            slidesPerView: 4
          },
          600: {
            slidesPerView: 5
          },
          800: {
            slidesPerView: 6
          }
        }
      },
      howToModalOpen: false,
      inCart: null,
      flushBbottom: {
        slidesPerView: 1,
      },
      homeImgLeft: true,
      isHeaderFixed2: false
    }
  },
  methods: {
    ...mapActions('cart', ['addProductToCart']),
    ...mapActions('products', ['fetchProductDetails']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    ...mapMutations('navbar', ['toggleWarehouseSelectionModalVisibility', 'toggleLoginModalVisibility',
     'toggleZipcodeModalVisibility', 'toggleShippingMethodModalVisibility','toggleShippingMethodModalVisibility_mobile']),
    setLocation() {
      this.toggleWarehouseSelectionModalVisibility(true);
    },
    capitalizeOnlyFirstLetter(string) {
      return string
      // let lowercase = string.toLowerCase();
      // return lowercase[0].toUpperCase() + lowercase.slice(1);
    },
    setNewCategory(category) {
      if (category.Name === 'All Categories') {
        this.$router.push('/collections')
      } else {
        this.selectedCategoryProducts = category;
        this.showMore = false;
      }
    },
    clickShowMore() {
      this.showMore = true;
    },
    homeImgCountChange() {
      this.homeImgLeft = !this.homeImgLeft;
      return true;
    },
    goToCollections() {
      this.$router.push('/collections')
    },
    goToCategory2(cat2) {
      this.$router.push(`/category2/${cat2.Name.toLowerCase()}`)
    },
    navGo(id) {
      const group = this.groups.filter(group => group.ProductGroup_id === id)[0];
      if (this.$router.currentRoute.params && this.$router.currentRoute.params.group) {
        if (this.$router.currentRoute.params.group.toLowerCase() !== group.Name.toLowerCase()) {
          // this.$router.push(`/collections/${group.Name.toLowerCase()}`)
          this.$router.push(`/collections`);
          setTimeout(() => {
            this.$root.selectNewGroup(group);
          }, 600);
        } else {
          // this.$root.fetchSelectedGroup(group.ProductGroup_id);
          this.$router.push(`/collections`);
          setTimeout(() => {
            this.$root.selectNewGroup(group);
          }, 600);
        }
      } else {
        // this.$router.push(`/collections/${group.Name.toLowerCase()}`)
        this.$router.push(`/collections`);
        setTimeout(() => {
          this.$root.selectNewGroup(group);
        }, 600);
      }
    },
    selectCustomCategory(cat2) {
      this.$router.push(`/collections`);
      setTimeout(() => {
        this.$root.selectNewCustomCategory(cat2);
      }, 600);
    },
    handleAddToCartSuccess(item) {
      this.$store.dispatch('cart/addCart', item)
        .then(() => {
          this.$store.dispatch('cart/getCart');
        });
    },
    handleAddToCartFail() {
      alert('Not enough product in stock');
    },
    findRightElement(item, p) {
      if (item.Product_id === p) {
        return
      }
    },
    setCategoryValues(newVal) {
      let oldCategories = JSON.parse(JSON.stringify(newVal));
      this.categories.splice(0, this.categories.length)
      this.selectedCategoryProducts = {
        Products: []
      }
      if (oldCategories.length < VERTICAL_NUM) {
        return
      }
      oldCategories.splice(0, VERTICAL_NUM)
      let arr = []
      oldCategories.forEach(item => {
        if (!item.IsButton && item.ListViewType !== 'middle-image') {
          arr.push(item)
        }
      })
      this.categories.push(...oldCategories)
      if (arr.length < 0) {
        return
      }
      this.categories.push({Name: 'All Categories', Description: '所有分類'})
      this.selectedCategoryProducts = arr[0]
    },
    onClickBillboard(url, type) {
      if (type === "URL") {
        window.location.href = url;
      } else if (type === "Category2") {
        Utils.$emit("clearList");
        this.$router.push(`/collections`);
        setTimeout(() => {
          this.$root.selectNewCustomCategory({Name: url});
        }, 300);
      } else if (type === "Group") {
        Utils.$emit("clearList");
        this.$router.push(`/collections`);
        setTimeout(() => {
          this.$root.selectNewGroup({Name: url});
        }, 300);
      } else if (type === "Category") {
        Utils.$emit("clearList");
        this.$router.push(`/collections`);
        setTimeout(() => {
          this.$root.selectNewCategory({Name: url});
        }, 300);
      } else {

      }
    },
    addToCart: function (item, event) {
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
          .then(() => {
            flyToElement(event.target, $('.cart-link'));
          })
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item)
          .then(() => {
            this.$store.dispatch('cart/getCart');
            flyToElement(event.target, $('.cart-link'));
          })
      }
    },
    beforeRouteLeave(to, from, next) {
      if (isUserAuthenticated() && to.name === 'purchase') {
        this.$store.dispatch('cart/getCart')
          .then(() => {
            const cartItems = {};
            cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
            cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
            cartItems.ShippingMethod = "Delivery";
            cartItems.Tip = 0;
            cartItems.TipPercentage = 0;
            cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
            this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
              .then(() => {
                this.saveGrandTotal(this.necessaryCartItems.GrandTotal);
                this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
              })
          })
      }
      this.clearPromoCode();
      this.clearCard();
      next();
    },
    checkViewableLanguages(data, lang) {
      for (let i = 0; i < data.split(',').length; i++) {
        let d = data.split(',')[i];
        if (d.toLowerCase()==='zh') { d = 'ch'}
        if (d.toLowerCase() === lang) {
          return true;
        }
      }
      return false;
    },
    toMobileViewAllPage(item) {
      this.$router.push({path:'/mobileViewAll?name='+encodeURIComponent(item.Name)})
    },
    fetchBillboardImages() {
      this.$store.dispatch('billboard/fetchBillboardImages');
    },
    fetchCustomCategories() {
      this.$store.dispatch('products/fetchCustomCategories',{company_id: 1,warehouse_id: 1});
    },
    windowScrollHandle() {
      if (!this.isMobile) return
      const searchBarCom = this.$refs.searchBarRef
      if (!searchBarCom) return
      const elRect = searchBarCom.getBoundingClientRect()
      const isHeaderFixed2 = elRect.top < 35
      if (isHeaderFixed2 === this.isHeaderFixed2) return
      this.isHeaderFixed2 = isHeaderFixed2
    }
  },
  computed: {
    ...mapState({
      checkoutWithinRadius: state => state.navbar.checkoutWithinRadius,
      checkoutRadiusChecked: state => state.navbar.checkoutRadiusChecked,
      cartProductsList: state => state.cart.cartProductsList,
      token: state => state.auth.token,
      loggedIn: state => state.auth.loggedIn,
      itemCount: state => state.cart.itemCount,
      necessaryCartItems: state => state.cart.necessaryCartItems,
      cartClicked: state => state.cart.cartClicked,
      itemAdded: state => state.cart.itemAdded,
      groups: state => state.navbar.allGroups,
      customCategories: state => state.products.customCategories,
      billboardImages: state => state.billboard.billboardImages,
      userDetails: state => state.auth.userDetails,
      shippingMethodGlobal: state => state.navbar.shippingMethodGlobal,
      userZip: state => state.navbar.userZip,
      warehouseLocation: state => state.navbar.warehouseLocation,
      windowWidth: state => state.navbar.windowWidth,
      isMobile() {
        return this.windowWidth < 800;
      },
    }),
    customButtonCategories() {
      return this.customCategories.filter(item => item.IsButton)
    },
    customNotBtnCategories() {
      const result = JSON.parse(JSON.stringify(this.customCategories.filter(item => !item.IsButton && this.getIsNotRecommended(item.Name))))
      return result.map(item => {
        return {
          ...item,
          Products: item.Products.reverse().sort(this.outOfStockToEnd)
        }
      })
    },
    showCustomNotBtnCategories() {
      return this.customNotBtnCategories.slice(0, VERTICAL_NUM)
    },
    filterBillboard({billboardImages, $i18n}) {
      const language = $i18n.locale;
      return billboardImages.filter(image => {
        return image.Language.toLowerCase() === language;
      })
    }
  },
  activated() {
    this.windowScrollHandle()
    if (!this.isMobile) {
      return
    }
    const customCategories = this.customCategories
    if (!Array.isArray(customCategories) || !customCategories.length) {
      this.fetchCustomCategories();
    }
    const billboardImages = this.billboardImages
    if (!Array.isArray(billboardImages) || !billboardImages.length) {
      this.fetchBillboardImages();
    }
  },
  watch: {
    $route(to, from) {
      if (to.path === '/') {
        this.fetchBillboardImages();
        this.fetchCustomCategories();
      }
    },
    customNotBtnCategories: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setCategoryValues(newVal);
      }
    },
  },
  created() {
    window.addEventListener('scroll', this.windowScrollHandle)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.windowScrollHandle)
  }
}
</script>

<style lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/home.less";
@import "../../assets/css/modal.less";
@import "../../assets/query/home.less";
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobileHome.vue